function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewCustomers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D9E5F8",
    style: {
      fill: "#D9E5F8",
      fill: "color(display-p3 0.8494 0.8973 0.9718)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1601 18.87C20.0601 18.86 19.9401 18.86 19.8301 18.87C17.4501 18.79 15.5601 16.84 15.5601 14.44C15.5601 11.99 17.5401 10 20.0001 10C22.4501 10 24.4401 11.99 24.4401 14.44C24.4301 16.84 22.5401 18.79 20.1601 18.87Z",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1602 22.56C12.7402 24.18 12.7402 26.82 15.1602 28.43C17.9102 30.27 22.4202 30.27 25.1702 28.43C27.5902 26.81 27.5902 24.17 25.1702 22.56C22.4302 20.73 17.9202 20.73 15.1602 22.56Z",
    stroke: "#3F7CDB",
    style: {
      stroke: "#3F7CDB",
      stroke: "color(display-p3 0.2471 0.4863 0.8588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewCustomers);
export default __webpack_public_path__ + "static/media/overview-customers.0aea0bd1d93de5000e411fd6085e1bc5.svg";
export { ForwardRef as ReactComponent };